import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  ClassificationReason,
  ClassificationReasonIcon,
  RenderWhen
} from "../../../../../components";
import {
  CLASSIFICATION_LABELS_AND_ICONS,
  isClassificationReasonExtractedFile,
  isClassificationReasonGoodwareOverride
} from "../../../../../components/ClassificationSource";

import { SECTIONS } from "../../../consts";
import { pathToSS } from "../../../util";
import { SUMMARY_FILE_CLASSIFICATIONS_ID } from "../../summary/SummaryFileClassifications";

type Props = {
  classificationSource: number;
  classificationReason: string;
  classificationReasonStyle: string;
  hasFileClassification: boolean;
  threatStatus: string;
};

const getTitle = (source: number, reason: string) => {
  if (isClassificationReasonExtractedFile(source)) {
    return "Extracted Files";
  }
  if (isClassificationReasonGoodwareOverride(source)) {
    return "Goodware Override";
  }
  return reason;
};

const ClassificationReasonCard = ({
  classificationReason,
  classificationReasonStyle,
  classificationSource,
  hasFileClassification,
  threatStatus
}: Props) => {
  const { hash = "", sourceId = "" } = useParams();
  const navigate = useNavigate();
  const { search } = useLocation();

  const title = getTitle(classificationSource, classificationReason);

  const handleSectionClick = () => {
    if (!hasFileClassification) return;
    const path = pathToSS(
      hash,
      sourceId,
      SECTIONS.FILE_ANALYSIS.HOW_WE_CAUGHT_THIS
    );
    navigate(`${path}${search}`, {
      state: { scrollTo: SUMMARY_FILE_CLASSIFICATIONS_ID }
    });
  };

  const label = CLASSIFICATION_LABELS_AND_ICONS[classificationSource]?.label;

  return (
    <ClassificationReason
      icon={
        <RenderWhen condition={threatStatus !== "unknown"}>
          <ClassificationReasonIcon
            source={classificationSource}
            style={classificationReasonStyle}
          />
        </RenderWhen>
      }
      label={label}
      title={title}
      onClick={handleSectionClick}
    />
  );
};

export default ClassificationReasonCard;
